<!-- Footer opened -->
<div class="main-footer ht-40">
    <div class="container-fluid pd-t-0-f ht-100p">
        <span>Copyright © 2026 VIAVI Solutions Inc.
            <!-- <a href="javascript:void(0)">Xino</a>. Designed by <a href="https://www.spruko.com/">Spruko</a> All rights reserved. -->
        </span>
    </div>
</div>
<!-- Footer closed -->